export default __webpack_public_path__ + "475c15ddf06d87364e6f8096ff5da7ca.png";